<template>
  <div>
    <div class="mb-4" style="display: flex; gap: 10px;">
      <vs-button 
        color="primary" 
        type="filled" 
        icon="refresh"
        @click="loadSuggestions"
        :loading="loading">
        {{ $t('Refresh') }}
      </vs-button>
      
      <vs-button 
        color="success" 
        type="filled" 
        icon="play_arrow"
        @click="forceProcessSignals"
        :loading="processing">
        {{ $t('ForceProcess') }}
      </vs-button>
    </div>

    <vs-table :data="suggestions">
      <template slot="thead">
        <vs-th>Email</vs-th>
        <vs-th>Signal Count</vs-th>
        <vs-th>Last Activity</vs-th>
        <vs-th>Status</vs-th>
        <vs-th>Actions</vs-th>
        <vs-th>{{ $t('SignalCount') }}</vs-th>
        <vs-th>{{ $t('LastActivity') }}</vs-th>
        <vs-th>{{ $t('Status') }}</vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td style="vertical-align: top">
              <p class="product-category">{{ tr.Email }}</p>
            </vs-td>
            <vs-td style="vertical-align: top">
              <vs-chip color="primary">
                {{ tr.SignalCount }} {{ $t('signals') }}
              </vs-chip>
            </vs-td>
            <vs-td style="vertical-align: top">
              <div class="product-category">
                <div v-for="(part, i) in formatDate(tr.LastSignalDate)" :key="i">
                  {{ part }}
                </div>
              </div>
            </vs-td>
            <vs-td style="vertical-align: top">
              <vs-chip v-if="tr.HasPendingInvitation" color="warning">
                {{ $t('AlreadyInvited') }}
              </vs-chip>
              <vs-chip v-else color="success">
                {{ $t('NewLabel') }}
              </vs-chip>
            </vs-td>
            <vs-td style="vertical-align: top">
              <vs-button v-if="!tr.HasPendingInvitation"
                         color="primary"
                         type="filled"
                         icon="person_add"
                         size="small"
                         @click="inviteUser(tr.Email)">
                {{ $t('Invite') }}
              </vs-button>
              <vs-chip v-else color="warning">
                Invitation Sent
              </vs-chip>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import TCVelikClient from '@/TCVelikClient/TCVelikClient';

export default {
  name: 'SuggestionsList',
  data() {
    return {
      suggestions: [],
      loading: false,
      processing: false
    };
  },
  mounted() {
    this.loadSuggestions();
  },
  methods: {
    async loadSuggestions() {
      this.loading = true;
      try {
        const response = await TCVelikClient.GetRelative('/api/signals/suggested-users');
        if (response && response.data) {
          this.suggestions = response.data;
        }
      } catch (error) {
        console.error('Failed to load suggested users:', error);
        this.$vs.notify({
          title: this.$t('Failed'),
          text: this.$t('FailedToLoadSuggestedUsers'),
          color: 'danger',
          position: 'top-right'
        });
      } finally {
        this.loading = false;
      }
    },
    
    async forceProcessSignals() {
      this.processing = true;
      try {
        const response = await TCVelikClient.PostRelative('/api/signals/process', {});
        
        if (response && response.data) {
          this.$vs.notify({
            title: this.$t('SuccessNotification'),
            text: this.$t('ProcessedSignals', { count: response.data.processedCount || 0 }),
            color: 'success',
            position: 'top-right'
          });
          
          // Reload suggestions after processing
          await this.loadSuggestions();
        }
      } catch (error) {
        console.error('Failed to process signals:', error);
        this.$vs.notify({
          title: this.$t('Failed'),
          text: this.$t('FailedToProcessSignals'),
          color: 'danger',
          position: 'top-right'
        });
      } finally {
        this.processing = false;
      }
    },
    
    formatDate(dateString) {
      if (!dateString) return ['-'];
      
      const date = new Date(dateString);
      const dateStr = date.toLocaleDateString(this.$i18n.locale || 'en', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
      const timeStr = date.toLocaleTimeString(this.$i18n.locale || 'en', {
        hour: '2-digit',
        minute: '2-digit'
      });
      
      return [dateStr, timeStr];
    },
    
    inviteUser(email) {
      // Emit event to parent component to open invite modal with pre-filled email
      this.$emit('invite-user', email);
    }
  }
};
</script>

<style scoped>
.product-category {
  font-size: 0.9rem;
}

.con-exemple-prompt {
  padding: 10px;
}
</style>

